import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GoogleSheetDatasetRunPayload } from '@mode/dataset/google/contract';

@Injectable({
  providedIn: 'root',
})
export class GoogleSheetSyncClientService {
  constructor(private _http: HttpClient) {}

  syncGoogleSheetDataset(accountId: string, datasetId: string) {
    // Include `trk_type` param in the url to filter google sheets requests in honeycomb
    return this._http.post<GoogleSheetDatasetRunPayload>(
      `/api/${accountId}/datasets/${datasetId}/runs?trk_type=google_sheet`,
      {}
    );
  }
}
